"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ActionAreaContainer = _ref => {
  var {
    children,
    direction = 'row'
  } = _ref;
  var classes = (0, _styles.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.actionAreaContainer, {
      'row': classes.alignRow,
      'column': classes.alignColumn,
      'columnReverse': classes.alignColumnReverse,
      'rowReverse': classes.alignRowReverse
    }[direction])
  }, children);
};
var _default = exports.default = ActionAreaContainer;